// extracted by mini-css-extract-plugin
export default {"wrapper":"yo-z","response":"zo-z","error":"Ao-z","disabled":"Bo-z","buttons":"Co-z","feedbackQuestionSection":"Do-z","yesNoWrapper":"Eo-z"};